import { Component, OnInit } from "@angular/core";
import {
    ActivatedRoute,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router,
} from "@angular/router";

@Component({
    selector: "app-solution-details",
    templateUrl: "./solution-details.component.html",
    styleUrls: ["./solution-details.component.scss"],
})
export class SolutionDetailsComponent implements OnInit {
    info: string;
    firstTitle: string;
    firstContent: string;
    firstImg: string;
    secondTitle: string;
    secondContent: string;
    secondImg: string;
    thirdTitle: string;
    thirdContent: string;
    thirdImg: string;
    fourthTitle: string;
    fourthContent: string;
    fourthImg: string;
    footerTitle: string;
    footerContent: string;
    footerImg: string;
    subTitle1: string;
    subTitle2: string;
    subTitle3: string;
    subTitleImg: string;
    textcolor: string;

    constructor(private route: ActivatedRoute, private router: Router) {
        this.route.queryParams.subscribe((params) => {
            this.info = params["info"];
        });
        router.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                $(".header-title").removeClass("active");
            }
        });
    }

    ngOnInit(): void {
        if (this.info == "so2") {
            $(".header-title:contains('商業智慧與預測分析BI & AI')").addClass(
                "active"
            );
        } else if (this.info == "資料庫與資料管理DB and DW") {
            $(".header-title:contains('資料庫與資料管理DB & DW')").addClass(
                "active"
            );
        } else {
            $(".header-title:contains(" + this.info + ")").addClass("active");
        }

        if (this.info == "so1") {
            this.info = "企業資源規劃 ERP 與 數位核心 Digital Platform";
            this.textcolor = "rgb(126, 198, 58)";
            this.firstTitle = "2021全球企業資源ERP未來：";
            this.firstContent =
                "<ul><li>雲計算將超過 4,000 億美元</li><li>因為技術不斷的進步，企業在未來五年中需要重新思考其人員配置策略</li><li>人工智慧(AI)、機器學習、自動化，幫助優化業務流程，創造更多個人化解決方案</li><li>ERP 與其他技術結合(例如: IoT, 社群媒體)創造更多商業價值</li><li>遠距工作與彈性應變納入方案選擇評估重點</li></ul>";
            this.firstImg = "assets/img/solution-details/pic_13.jpg";
            this.secondTitle = "數位轉型 & 企業核心";
            this.secondContent =
                "<span>碩達系統</span>協助客戶全面檢視及優化企業核心作業流程，導入企業資源規劃(ERP)系統，整合及運用物聯網、大數據分析、機器學習、流程自動化...等數位科技，為客戶發展全方位的商業平臺力。<br><br><span>企業進化關鍵：</span><ul><li><span>優化決策</span><br>即時洞察預測，輔助制訂最佳決策</li><li><span>績效提升</span><br>端到端重塑流程，績效表現更亮眼</li><li><span>提高產能</span><br>數位世代使用者體驗與智慧助理，生產力大幅提升</li><li><span>精實控管</span><br>簡化系統架構與雲端部署模式，降低投入成本</li></ul>";
            this.secondImg = "assets/img/solution-details/pic_14.jpg";
            this.footerTitle = "彈性擴充 • 適能適性";
            this.footerContent =
                "<span>碩達系統</span>為各種規模企業提供合適 ERP 解決方案，同時也提供產業及公司專屬的功能，滿足獨一無二的商務需求。<br><br>◼&nbsp;&nbsp;&nbsp;中小企業：彈性應用，地端或雲端快速佈署；為未來企業擴張奠定基礎。<br>◼&nbsp;&nbsp;&nbsp;大型與跨國集團：結合智慧科技，彈性佈署，企業級解決方案符合國際交易標準，協助企業建立透明化與標準化流程。";
            this.footerImg = "assets/img/solution-details/pic_16.jpg";
            this.subTitle1 = "企業流程再造";
            this.subTitle3 =
                "整合平臺：所有業務營運環環相扣，高度清晰可視，為未來商業版圖打造全面營運戰情室";
            this.subTitleImg = "assets/img/solution-details/pic_15.png";
        } else if (this.info == "so2") {
            this.info = "商業智慧與預測分析BI and AI";
            this.textcolor = "#2781bd";
            this.firstTitle = "2021 數據與分析趨勢：";
            this.firstContent =
                "<ul><li>雲端化：高彈性，可擴充，整合數據儲存、分析、數據模型和源以及計算能力，更廣泛運用 AI、ML 技術</li><li>數據驅動：以數據結構為基礎，設計以使用/重用和組合不同數據集合的能力，可針對獨特業務模型定制新想法</li><li>改善數據安全性：數據洩漏導致公信度與市場價值下降，隨著數據驅動型業務的發展，安全性的提升格外重要</li><li>遠距工作與彈性應變納入方案選擇評估重點</li><li>數據品質管理（DQM）：BI 證明數據的價值，但數據的價值完全取決於所使用數據的品質，結合人才、技術、組織文化提高數據分析應用與預測能力</li></ul>";
            this.firstImg = "assets/img/solution-details/pic_20.jpg";
            this.secondTitle = "數據賦能&決策洞察";
            this.secondContent =
                "<span>碩達系統</span>從數位化創新分析技術藍圖設計與開發到技術支援提供完整解決方案。其中包含數據收集、數據清理、多維度分析、可視化儀表板以及商業智慧平台建置與管理。我們的專家憑藉豐富的專業知識豐富協助客戶實現及擴大其企業商業價值，找出資訊技術可以協助的價值位置，以顯現企業的核心競爭力。<br><br><span>企業進化關鍵：</span><ul><li><span>多維度資料分析建模 (Data Modeling)</span><br>在平台上進行資料建模、多維度分析</li><li><span>擷取資料來源 (ETL)</span><br>存取及整合企業異質系統，進行資料萃取、清理、轉換和整合</li><li><span>開發分析報表 (Reporting)</span><br>透過互動分析方式分析資料，開發企業管理報表</li><li><span>關鍵績效指標分析 (KPI Dashboard)</span><br>企業戰情室儀表板，獲取即時及綜觀的分析性企業資訊</li><li><span>商業智慧平台管理 (BI Platform Management)</span><br>執行系統維運管理、效能監控、權限設定等</li></ul>";
            this.secondImg = "assets/img/solution-details/pic_21.jpg";
            this.subTitle1 = "數據策略資產計畫";
            this.subTitle2 =
                "掌握即時洞察滿足企業、客戶、商業夥伴及員工的各方需求";
            this.subTitle3 = "數據+分析+應用";
            this.subTitleImg = "assets/img/solution-details/pic_22.png";
        } else if (this.info == "so3") {
            this.info = "顧客管理 CRM 與客戶體驗 CX";
            this.textcolor = "rgb(126, 198, 58)";
            this.firstTitle = "體驗模式轉變，從被動等待到主動出擊";
            this.firstContent =
                "Moxtra 首席執行官兼聯合創始人、WebEx 前首席執行官、董事長兼聯合創始人 Subrah Iyar 指出：<br><span>「消費者的期望已經數位化且無法逆轉，即使疫情結束，便利和靈活的顧客體驗都將持續進行。企業需要數位化解決方案來保持客戶滿意度與業務的持續發展。這表示客戶參與體驗將從”推動Push”模式轉變為”拉動Pull”」</span><br><span>Forbes 報導指出：</span><br><ul><li>73% 的客戶體驗高於平均水平的公司在財務上的表現優於競爭對手</li><li>96% 的客戶表示，客戶服務對於他們選擇對品牌的忠誠度很重要</li><li>具有卓越客戶體驗的品牌帶來的收入是落後於客戶體驗的競爭對手的5.7倍</li><li>客戶因服務差而更換公司的成本總計 1.6 萬億美元</li><li>以客戶為中心的公司比不以客戶為中心的公司的利潤高60%</li></ul><span>Market Research Future 預測：</span>到2023年，CRM市場將增長到350億";
            this.firstImg = "assets/img/solution-details/pic_33.jpg";
            this.secondTitle = "整合應用 & 多元多變";
            this.secondContent =
                "企業以往以不同形式建立與蒐集客戶資料，這些資料分散在不同的地方與系統，例如: 行銷部門、業務部門、線上銷售部門，又或者是實體販售通路無法取得客戶資料、線上線下資料不能整合，失去再銷售的機會；在新世代的競爭市場，顧客管理強化與體驗提升格外重要。<br><br><span>強化重點：</span><ul><li><span>去蕪存菁與妥善應用</span><br>串聯資訊、客戶群分類，提高客戶忠誠度和保留率</li><li><span>多元接觸與品質提升</span><br>多通路整合資訊、產品與銷售分析、端到端的整體評估</li><li><span>智能技術與自助服務</span><br>機器人（AI和ML）將協助員工與客戶更快得到想要的內容</li><li><span>管理升級與未來評估</span><br>數據可視化和IT儀表板，提供企業制定銷售策略與調整專案項目</li></ul>";
            this.secondImg = "assets/img/solution-details/pic_34.jpg";
            this.thirdTitle = "顧客管理系統CRM";
            this.thirdContent =
                "CRM 確保企業運作彈性，不僅是與現行與潛在客戶建立關聯，包括維繫客戶關係與動態儲存客戶歷史記錄的同時，培養與建立忠誠度，並且讓公司團隊可以使用相關資料，甚至透過第三方軟體整合形成更多應用，從商機、銷售訂單、履行、續訂、追加銷售、交叉銷售和支援等不同面向執行，貫穿客戶銷售生命週期。而因應不同企業需求，<span>碩達系統</span>協助規劃雲端或落地方案，讓企業提升「全面體驗」，有效創造競爭優勢。<br><br><span>評估方式：</span><br><ul><li><span>雲端方案</span><br>跨國企業、子公司、加盟連鎖型態需要快速建立系統，導入速度快、初始費用低、建置期短，可以快速複製模式加快拓展速度</li><li><span>落地方案</span><br>集團、跨國企業、資訊品牌與ERP 整合需求，資訊升級全面化考量，為未來企業發展進行藍圖策略規劃</li></ul>";
            this.thirdImg = "assets/img/solution-details/pic_35.jpg";
            this.fourthTitle = "顧客體驗提升CX";
            this.fourthContent =
                "CX ( Customer Experience)，囊括顧客旅程以及企業前後端資訊串流的經歷，企業進行改善與提升計畫時，有各種不同的切入點，其中包含如何透過廣告、市場行銷、銷售、商務和服務之間的所有業務資料連結，建立客戶互動資訊進行項目規劃；內部系統與應用開發程式的優化，加強服務內容；客戶自助介面與智能應用服務的提供，加速溝通與消費管道的暢通。<span>碩達系統</span>將依照企業屬性以及現行營運方式，協助進行評估，提供最適方案，協助企業建立愉快、無縫的品牌體驗。";
            this.fourthImg = "assets/img/solution-details/pic_36.jpg";
        } else if (this.info == "so4") {
            this.info = "企業營運不中斷戰術";
            this.textcolor = "#2781bd";
            this.firstTitle = "企業營運不能等，遠距安心不怠工";
            this.firstContent =
                "Covid-19的疫情，不但影響全世界的生活型態，更意外的提早了資訊演化進程，加速遠距教學及遠距工作的腳步。<br>在整個資訊大環境的演化過程中，大部分的企業工作，急遽的轉換成為全部或部分的遠距工作型態，突然的架構變更下，伴隨而來的卻是資安風險的大幅增加，衍生許多重大的資訊安全事件，因此，保護企業資訊變成一個非常重要的課題。";
            this.firstImg = "assets/img/solution-details/pic_37.jpg";
            this.secondTitle = "VPN (虛擬專用網路) 解決方案";
            this.secondContent =
                "虛擬專用網路VPN 的建置，可以保護員工在遠距上班的狀況下，除了透過專用網路正常存取公司資源，並保證員工及公司資訊不被有心人士竊取。員工的工作、密碼、訊息和其他資料對於任何試圖存取它們的人來說都是難以理解的混亂資訊。在有限的預算下， VPN易於維護，建置快速，對於企業來說是最為經濟的遠距工作方案。";
            this.secondImg = "assets/img/solution-details/pic_38.jpg";
            this.thirdTitle = "VDI (遠端虛擬桌面) 解決方案";
            this.thirdContent =
                "桌面的虛擬化技術，可以讓員工雖然在遠端工作，但所有的企業資訊依然保存在資訊中心內部，確保機密資料不外流及不落地。對於企業來說，VDI 提供了一套完整的員工工作環境虛擬化及集中化的管理技術。 VDI 是一種在任意地點、任意設備、以安全且受管理的企業工作區方式，讓員工取用所需的企業應用及文件。企業的 IT 人員，也不必再為使用者操作問題必須到場協助，只需在資訊中心內部即可管理所有使用者畫面及協助處理，大大節省企業營運的時間及成本。";
            this.thirdImg = "assets/img/solution-details/pic_39.jpg";
            this.fourthTitle =
                "End-Point Protection (端點防護資訊安全) 解決方案";
            this.fourthContent =
                "企業主不但要對企業機敏資料訂下保護政策，更要定義員工端點設備的資訊安全規範。員工電腦的病毒感染，異常的資料存取或惡意的破壞，極可能成為不定時炸彈，讓維護多年的資安門檻邊界防禦崩潰，小則員工資訊外洩或流失，大則可能造成企業資訊災難，蒙受極大損失。導入端點管理及安全防護，可針對網路資源濫用、內部洩密、外部安全威脅等議題做有效的管理，納入伺服器、端點電腦及其周邊裝置，阻絕不安全的電腦及網路使用行為。透過稽核機制，保護企業智慧資產、避免重要檔案外洩，協助企業以更簡單、有效的方式實現端點管理與安全防護。";
            this.fourthImg = "assets/img/solution-details/pic_40.jpg";
        }
    }
    ngAfterViewInit() {}
}
